import React from "react";
import { Divider } from "antd";
import InfoSlider from "../../../components/Restaurant/Dashboard/InfoSlider";
import {
    InvoiceIcon,
    MessageIcon,
    PendingOrder,
    VolumeUpIcon,
} from "../../../common/utils/Icons";

const BikerDashboardHeader = ({ metrics, loading }) => {
    const stats = [
        {
            title: "Today's Deliveries",
            value: metrics?.delivered ?? 0,
            icon: PendingOrder,
            color: "color_5",
        },
        {
            title: "Delivery Wallet",
            value: metrics?.walletBalance ?? 0,
            icon: MessageIcon,
            color: "color_1",
            isCurrency: true,
        },
        {
            title: "Completion Rate",
            value: `${metrics?.completionRate ?? 0}%`,
            icon: InvoiceIcon,
            color: "color_2",
        },
        {
            title: "Income Till Date",
            value: metrics?.totalIncome ?? 0,
            icon: VolumeUpIcon,
            color: "color_1",
            isCurrency: true,
        },
    ];

    return (
        <>
            <div className="pt-10">
                <h5 className="text-4xl text-gray-900 font-bold">Biker's Portal</h5>
                <Divider style={{ margin: "15px 0 5px" }} />
            </div>
            <InfoSlider stats={stats} />
        </>
    );
};

export default BikerDashboardHeader;
